import React from "react";
import { Toaster } from "sonner";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import AppContent from "./pages/AppContent";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;